module.exports = __webpack_public_path__ + "img/chat.3ded5970.svg";